import styled from 'styled-components';

export const LayoutRow = styled.div`
  border: 1px solid var(--color-border);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;

  .layout-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 250px;
  }

  .layout-name {
    font-weight: 600;
    color: var(--color-text);
  }

  .layout-meta {
    color: var(--color-text-muted);
    font-size: 12px;
  }

  .layout-links {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    a {
      color: var(--color-accent);
      text-decoration: underline;
      font-size: 12px;
    }
  }

  .actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 260px;
  }
`;
